// Main exports for the bridge module
export { BridgeApi } from './BridgeApi';
export type { BridgeApiConstructorType } from './BridgeApi';

// Type exports
export type {
  BridgeCallback,
  BridgeEventType,
  BridgeRequest,
  EventLogging,
  GetAccessToken,
  GetImage,
  OpenDialogRequest,
  OpenUrl,
  SetHistoryBackBlock,
  SetMainTabBarVisibility,
  WebViewMessage,
  NativeResponse,
  BridgeHandler,
  BridgeHandlers,
} from './types';

// Enum exports
export { BridgeEvent, EnvType, AccessTokenResponseType } from './types';

// Utility exports
export { getBase64Image, isValidImageUri, createWebBridgeApi } from './utils';
